import type { SortingState } from '@tanstack/table-core'

import type { TableSettingsState } from '@/helpers/cookieStorage/userSettings/tableSettings/shared'

import { TransactionType } from '@/types/legacy'

export const PAGE_SIZE = 10

export const COLUMN_IDS = {
  Timestamp: 'Timestamp',
  TypeText: 'TypeText',
  AssetsUsd: 'AssetsUsd',
  TransactionHash: 'TransactionHash'
} as const

export const MARKET_YOUR_TRANSACTIONS_INITIAL_SORTING: SortingState = [
  {
    id: COLUMN_IDS.Timestamp,
    desc: true
  }
]

export const MARKET_YOUR_TRANSACTIONS_DEFAULT_TABLE_SETTINGS: TableSettingsState = {
  columnVisibility: {},
  sorting: MARKET_YOUR_TRANSACTIONS_INITIAL_SORTING,
  columnFilters: [],
  columnOrder: [],
  // Bumping version to force resetting user settings
  version: 1
}

export const MARKET_YOUR_TRANSACTIONS_STORAGE_KEY = 'marketYourTransactionsTable'

export const TRANSACTION_FILTER_OPTIONS = [
  { label: 'Withdraw', value: TransactionType.MarketWithdraw },
  { label: 'Withdraw Collateral', value: TransactionType.MarketWithdrawCollateral },
  { label: 'Lend', value: TransactionType.MarketSupply },
  { label: 'Supply Collateral', value: TransactionType.MarketSupplyCollateral },
  { label: 'Borrow', value: TransactionType.MarketBorrow },
  { label: 'Repay', value: TransactionType.MarketRepay }
]
